// Иконки и порядок сортировки для категорий коротких курсов
const categories: Record<number, { icon: string; sort: number, title: string }> = {
  40: {
    title: 'recommendations',
    icon: 'recommendations',
    sort: 1
  },
  41: {
    title: 'new',
    icon: 'new',
    sort: 2
  },
  42: {
    title: 'top_sales',
    icon: 'top_sales',
    sort: 3
  },
  // Фейсфитнес
  7: {
    title: 'facefitness',
    icon: 'facefitness',
    sort: 1
  },
  // Йога
  4: {
    title: 'yoga',
    icon: 'yoga',
    sort: 2
  },
  // Здоровье
  14: {
    title: 'health',
    icon: 'health',
    sort: 3
  },
  // Антивозрастные практики
  33: {
    title: 'antiaging',
    icon: 'antiaging',
    sort: 4
  },
  // Похудение и контроль веса
  34: {
    title: 'weightLoss',
    icon: 'weight-loss',
    sort: 5
  },
  // Саморазвитие
  35: {
    title: 'selfDevelopment',
    icon: 'self-development',
    sort: 6
  },
  // Фитнес
  5: {
    title: 'fitness',
    icon: 'fitness',
    sort: 7
  },
  // Материнство
  24: {
    title: 'motherhood',
    icon: 'motherhood',
    sort: 8
  },
  // Здоровье малыша
  36: {
    title: 'childHealth',
    icon: 'child-health',
    sort: 9
  },
  // Антистресс и медитации
  37: {
    title: 'antiStressAndMeditation',
    icon: 'anti-stress-and-meditation',
    sort: 10
  },
  // Здоровое питание
  1006: {
    title: 'nutrition',
    icon: 'nutrition',
    sort: 10
  },
  // Тейпирование
  16: {
    title: 'taping',
    icon: 'taping',
    sort: 11
  },
  // Женское здоровье
  29: {
    title: 'womenHealth',
    icon: 'women-health',
    sort: 12
  },
  // Лимфодренаж
  38: {
    title: 'lymphaticDrainage',
    icon: 'lymphatic-drainage',
    sort: 13
  },
  // Красота
  10: {
    title: 'beauty',
    icon: 'beauty',
    sort: 14
  },
  // Беременность и роды
  1008: {
    title: 'pregnancyAndBirth',
    icon: 'pregnancy-and-birth',
    sort: 15
  },
  // Макияж и волосы
  1009: {
    title: 'makeupAndHair',
    icon: 'makeup-and-hair',
    sort: 18
  },
  // Самомассаж и массаж тела
  1010: {
    title: 'selfMassageAndBodyMassage',
    icon: 'self-massage-and-body-massage',
    sort: 19
  },
  // Танцы и растяжка
  9: {
    title: 'dance',
    icon: 'dance',
    sort: 20
  },
  // HIIT
  6: {
    title: 'hiit',
    icon: 'hiit',
    sort: 999
  },
  // Женские практики
  12: {
    title: 'womenPractices',
    icon: 'women-practices',
    sort: 999
  },
  // Искусство
  13: {
    title: 'art',
    icon: 'art',
    sort: 999
  },
  // Красота и здоровье
  25: {
    title: 'beautyAndHealth',
    icon: 'beauty-and-health',
    sort: 999
  },
  // Кулинария
  17: {
    title: 'cooking',
    icon: 'cooking',
    sort: 999
  },
  // Медитация
  19: {
    title: 'meditation',
    icon: 'meditation',
    sort: 999
  },
  // Мнемотехники
  21: {
    title: 'mnemonics',
    icon: 'mnemonics',
    sort: 999
  },
  // Нейросети
  32: {
    title: 'neuralNetworks',
    icon: 'neural-networks',
    sort: 999
  },
  // Пилатес
  8: {
    title: 'pilates',
    icon: 'pilates',
    sort: 999
  },
  // Психология
  27: {
    title: 'psychology',
    icon: 'psychology',
    sort: 999
  },
  // Тейпирование для здоровья
  22: {
    title: 'tapingForHealth',
    icon: 'taping-for-health',
    sort: 999
  },
  // Умный фитнес
  31: {
    title: 'smartFitness',
    icon: 'smart-fitness',
    sort: 999
  },
  // Финансы
  28: {
    title: 'finance',
    icon: 'finance',
    sort: 999
  }
}

export default categories
